
































































































import { Component, Vue } from 'vue-property-decorator';
import { doublePrevention } from '@/api/installServer';

@Component
export default class Dialog2 extends Vue {
  private dialogVisible = false;

  private controlMeasuresDataList: any = [];

  // 表单数据
  private formData: any = {};
  public async showDialog(data: any) {
    this.dialogVisible = true;
    this.getData(data.id);
  }
  private getData(id: any) {
    doublePrevention.getRiskControlInventoryDetail(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.controlMeasuresDataList = [res.data.technologyMeasureHazardList, res.data.individualProtectShowHazardList, res.data.controlMeasuresHazardList];
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  handleClose(done: any) {
    done();
  }
}
